import { get, post } from '../utils/request';

// 定义接口返回的数据类型




// 保存银行卡
export const saveCard = (data: any) => {
  return post<any>('/card/save_card', data);
};



// 获取用户银行卡列表
export const getUserCardList = () => {
  return get<any>('/card/get_card');
};

// 解绑银行卡
export const deleteCard = (data: any) => {
  return post<any>('/card/save_delete_card', data);
};
